module.exports = __webpack_public_path__ + "img/GT.b5fbfc5d.png";